module.exports = {"pageTitleText":"第三方API金钥","hintText":"请确认ID及KEY匹配正确，避免造成功能异常。","captcha":"Smart Captcha","vaptcha":"Gesture Challenge","placeholder":"请输入"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/apiKeys.json
// module id = FV6L
// module chunks = 3